/**
 * Card types
 *
 * @type {object}
 */
export const types = {
  visa: 'visa',
  master: 'master',
  jcb: 'jcb',
  discover: 'discover',
  dinersclub: 'dinersclub',
  amex: 'amex',
  belkart: 'belkart',
  unionpay: 'unionpay',
  ga: 'ga'
};
/**
 * Card types titles
 *
 * @type {object}
 */

export const typesTitles = {
  [types.visa]: 'Visa',
  [types.master]: 'Master',
  [types.jcb]: 'Jcb',
  [types.discover]: 'Discover',
  [types.dinersclub]: 'Dinersclub',
  [types.amex]: 'Amex',
  [types.belkart]: 'Belcart',
  [types.unionpay]: 'Unionpay',
  [types.ga]: 'IOS/Android Pay'
};